// extracted by mini-css-extract-plugin
export var actionButton = "_fr-0";
export var fileInput = "_fr-2";
export var paperclip = "_fr-1";